<template>
<div class="smart-form">
  <div class="smart-icon">
      <img src="../assets/bahn.png" width="120px"/>
     </div>
    <div class="screentime-hl">Wie viele Personen reisten 2021 durchschnittlich pro Jahr mit dem ICE?</div>
    
  <div class="screentime-form">
      <form v-if="hasQuizForm"> 
        <br>
           <div class="inner-form">
         <button class="gen_button" v-on:click.prevent="generateOption1"> 57 Millionen</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption2">99 Millionen</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption3">77 Millionen</button>
<br>
 <br>
</div></form>
  </div>
  <div v-if="hasChoosen" class="smartphone-dataviz">
  <br>
         <div class="screentime-description" v-html="quizDescription"> <br><br>
        </div>
    <br><br>
   <div class="dataviz-source"> Quelle: Deutsche Bahn</div>
  </div>
  </div>
</template>


<script>
export default {
  name: 'Quiz',
  props: {
    
  },
  data() {
        return {
            optionChoosen: "",
            hasChoosen: false,
            hasQuizForm:true       }     
    },
    computed: {
       
         quizDescription: function () {
        let smartAppMsg="";
        
            if (this.optionChoosen == "Option1") {
                smartAppMsg= "Mit ihrer Antwort liegen Sie genau richtig!<br><br><b>Rund 57 Millionen </b><br>Fahrgäste reisten im Jahr 2021 mit einem ICE der Deutschen Bahn. <br><br>Dies sind deutlich weniger als 2019, als es noch knapp <b>99 Millionen Fahrgäste</b> waren. Der Rückgang ist auf die gesunkene Mobilität im Zuge der Corona-Pandemie zurückzuführen."
            }
            if (this.optionChoosen == "Option2") {
                smartAppMsg= "Sie haben 99 Millionen gewählt. Da haben Sie wohl eine ältere Statistik gesehen! <br><br><b>Rund 57 Millionen </b>Fahrgäste reisten im Jahr 2021 mit einem ICE der Deutschen Bahn. <br><br>Dies sind deutlich weniger als 2019, als es noch knapp <b>99 Millionen Fahrgäste</b> waren. Der Rückgang ist auf die gesunkene Mobilität im Zuge der Corona-Pandemie zurückzuführen."
            }
            if (this.optionChoosen == "Option3") {
                smartAppMsg= "Sie haben 77 Millionen gewählt. Damit liegen Sie leider daneben! <br><br><b>Rund 57 Millionen </b><br>Fahrgäste reisten im Jahr 2021 mit einem ICE der Deutschen Bahn. <br><br>Dies sind deutlich weniger als 2019, als es noch knapp <b>99 Millionen Fahrgäste</b> waren. Der Rückgang ist auf die gesunkene Mobilität im Zuge der Corona-Pandemie zurückzuführen."
            }
                        
            return (smartAppMsg)
            }
            
       

    },
  methods: {
        generateOption1: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option1";
           
           }  
        },
         generateOption2: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option2";
           
           }  
        },
         generateOption3: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option3";
           
           }  
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/styles.css';
</style>
